import SearchManager from './_searchManager'

const store = new SearchManager()
store.search = {
  items: [],
  meta: {
    query: '',
    totalItems: 0,
    perPage: 10,
    currentPage: 0,
  },
  urls: {
    search: '',
    content: '',
  },
  nonce: '',
  hp: '',
}

store.addItems = function (items) {
  this.search.items = items
}

store.hasItems = function () {
  if (!this.search.items) {
    return false
  }

  return !!this.search.items.length
}

store.getItems = function () {
  return this.search.items
}

store.clearSearch = function () {
  this.search.items = []
}

store.updateMeta = function (key, value) {
  if (key in this.search.meta) {
    this.search.meta[key] = value
  }
}

store.meta = function (key) {
  return this.search.meta?.[key]
}

store.updateUrls = function (key, value) {
  if (key in this.search.urls) {
    this.search.urls[key] = value
  }
}

store.urls = function (key) {
  return this.search.urls?.[key]
}

store.totalPages = function () {
  return Math.ceil(this.search.meta.totalItems / this.search.meta.perPage)
}

export default store
